/* global Swiper */
// *******************************************************************************
// 1.0 - Event slider
// *******************************************************************************

const EventSliderElements = document.querySelectorAll('[data-slider="event-slider"]');

const EventSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
};

EventSliderElements.forEach((el) => {
  const EventSliderParent = el.closest('.sc-event-slider');
  const arrowRight = EventSliderParent.querySelectorAll('.arrow-right')[0];
  const arrowLeft = EventSliderParent.querySelectorAll('.arrow-left')[0];

  EventSliderOptions.navigation.nextEl = arrowRight;
  EventSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const EventSlider = new Swiper(el, EventSliderOptions);
});
